import React, { FC, ReactNode } from 'react';
import { Controller, Control } from 'react-hook-form';
import { PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';
import { ErrorText } from '../Elements';
import FormLabel from './FormLabel';
import { useFetchCountryByIPQuery } from '@/store/apis/coreApi';

interface PhoneInputFieldProps {
  label?: string;
  control: Control<any>;
  name: string;
  error?: string;
  required?: boolean;
  suffix?: string | ReactNode;
}

const PhoneInputField: FC<PhoneInputFieldProps> = ({
  label,
  control,
  name,
  error,
  required = false,
  suffix,
}) => {
  const { data } = useFetchCountryByIPQuery();
  return (
    <div>
      {label && (
        <FormLabel
          required={required}
          label={
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span>{label}</span>{' '}
              <span style={{ color: 'red', fontSize: '24px' }}>*</span>
            </div>
          }
        />
      )}
      <div className="input-container" style={{ position: 'relative' }}>
        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <PhoneInput
              className="custom-phone-input"
              defaultCountry={data?.data?.country.toLowerCase()}
              value={field.value || ''}
              onChange={(phone, meta) => {
                const isPhoneNumberValid =
                  phone.length > meta.country.dialCode.length + 1;

                field.onChange(isPhoneNumberValid ? phone : '');
              }}
            />
          )}
        />
        {suffix && (
          <div
            className="suffix"
            style={{
              position: 'absolute',
              right: 0,
              top: 0,
              translate: '-50% 50%',
            }}
          >
            {suffix}
          </div>
        )}
      </div>
      {error && <ErrorText error={error} />}
    </div>
  );
};

export default React.memo(PhoneInputField);
